import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'DocumentType/Entities', method: 'GET', body: null, token: token })
}
